import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { TimePeriods } from '@shared';

@Component({
  selector: 'mojo-job-salary-part-time',
  templateUrl: './job-salary-part-time.component.html',
  styleUrls: ['./job-salary-part-time.component.scss'],
})
export class JobSalaryPartTimeFormComponent {
  @Input() form: UntypedFormGroup;
  timePeriods = TimePeriods;
  timePeriodsList = Object.values(this.timePeriods);
}
